interface NumberWidgetProps {
  data?: any
  config?: Record<string, any>
}

export function NumberWidget({ data, config }: NumberWidgetProps) {
  let value: number | string | null = null

  if (data && Array.isArray(data) && data.length > 0) {
    const firstRow = data[0]
    const valueKey = config?.valueKey || Object.keys(firstRow)[0]
    const rawValue = firstRow[valueKey]
    if (rawValue != null && rawValue !== "") {
      value = typeof rawValue === "number" ? rawValue : String(rawValue)
    }
  }

  const formatValue = (val: number): string => {
    if (config?.format === "currency") {
      return new Intl.NumberFormat("en-US", { style: "currency", currency: config?.currency || "USD" }).format(val)
    }
    if (config?.format === "percent") {
      return `${(val * 100).toFixed(config?.decimals || 2)}%`
    }
    return val.toLocaleString("en-US", {
      minimumFractionDigits: config?.decimals ?? 0,
      maximumFractionDigits: config?.decimals ?? 2,
    })
  }

  const displayValue = value == null ? null : typeof value === "number" ? formatValue(value) : value
  const fontSize = config?.fontSize || 64
  const textColor = config?.color || undefined
  const labelColor = config?.labelColor || undefined

  return (
    <div className="flex h-full items-center justify-center">
      <div className="flex flex-col items-center justify-center gap-4">
        {config?.label && (
          <div className="text-sm font-medium" style={{ color: labelColor }}>
            {config.label}
          </div>
        )}
        {displayValue != null ? (
          <div
            className="font-bold"
            style={{
              fontSize: `${fontSize}px`,
              color: textColor,
              lineHeight: 1.2,
            }}
          >
            {displayValue}
          </div>
        ) : (
          <div className="text-sm text-gray-500 dark:text-gray-400">No data</div>
        )}
      </div>
    </div>
  )
}
